/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;



//////////////////
// WEBPACK FOOTER
// ./node_modules/normalizr/node_modules/lodash/_freeGlobal.js
// module id = 264
// module chunks = 0